import React from 'react';

const OpisHeadingu = (props) => {
    return (
        <div className={`${props.default ? 'max-w-sm' : props.glowneStyle} `}>
            <p className={`${props.center ? 'text-center' : ''} 
                            font-sen text-${props.fontSize} tracking-wider`}>
                {props.tytul}
            </p>
            <p className='relative top-[2rem] text-gray-400 font-futura text-lg'>
                {props.opis}
            </p>
            {props.children}
        </div>
    );
}

export default OpisHeadingu;
